// extracted by mini-css-extract-plugin
export default {"container":"RegisteredEvent_container__62dbX"};